import BaptismOrdinance from './BaptismOrdinance'
import ConfirmationOrdinance from './ConfirmationOrdinance'
import InitiatoryOrdinance from './InitiatoryOrdinance'
import EndowmentOrdinance from './EndowmentOrdinance'
import SealingToSpouseOrdinance from './SealingToSpouseOrdinance'
import SealingToParentOrdinance from './SealingToParentOrdinance'

export default class OrdinanceParser {
  constructor({
    data: {
      baptism = {},
      confirmation = {},
      initiatory = {},
      endowment = {},
      sealingToSpouse = {},
      sealingToParents = {},
    },
    t,
  }) {
    this.t = t

    this.allData = []
    this.allData.push(new BaptismOrdinance(baptism, t))
    this.allData.push(new ConfirmationOrdinance(confirmation, t))
    this.allData.push(new InitiatoryOrdinance(initiatory, t))
    this.allData.push(new EndowmentOrdinance(endowment, t))

    if (Array.isArray(sealingToSpouse)) {
      sealingToSpouse.forEach((sealing) => {
        this.allData.push(new SealingToSpouseOrdinance(sealing, t))
      })
    } else {
      this.allData.push(new SealingToSpouseOrdinance(sealingToSpouse, t))
    }

    if (Array.isArray(sealingToParents)) {
      sealingToParents.forEach((sealing) => {
        this.allData.push(new SealingToParentOrdinance(sealing, t))
      })
    } else {
      this.allData.push(new SealingToParentOrdinance(sealingToParents, t))
    }
  }

  prepareListForDisplay = (ordinance, index) => {
    ordinance.key = index + 1
  }

  buildOrdinanceList = () => {
    this.allData.forEach((ordinance, index) => {
      this.prepareListForDisplay(ordinance.data, index)
    })

    return this.allData.map((ordinance) => ordinance.data)
  }
}
